let authConfig;
export const configureAuth = (config) => {
    authConfig = config;
};
/**
 * It will make an authenticated
 * "POST" request to the url
 * @param url
 * @param init
 * @returns
 */
export const sendPost = (url, init) => {
    return send(url, {
        ...init,
        method: 'POST'
    });
};
/**
 * It will make an authenticated
 * "GET" request to the url
 * @param url
 * @param init
 * @returns
 */
export const sendGet = (url, init) => {
    return send(url, {
        ...init,
        method: 'GET'
    });
};
/**
 * It will make an authenticated
 * "DELETE" request to the url
 * @param url
 * @param init
 * @returns
 */
export const sendDelete = (url, init) => {
    return send(url, {
        ...init,
        method: 'DELETE'
    });
};
/**
 * It will make an authenticated
 * "UPDATE" request to the url
 * @param url
 * @param init
 * @returns
 */
export const sendUpdate = (url, init) => {
    return send(url, {
        ...init,
        method: 'UPDATE'
    });
};
/**
 * By using this function, you can make
 * an authenticated request to given url
 * @param url
 * @param init
 * @returns
 */
export const send = async (url, init) => {
    const urlObject = new URL(url);
    const accessToken = await fetchAccessToken(urlObject);
    return fetch(urlObject.toString(), {
        ...init,
        headers: {
            ...init?.headers,
            Authorization: `${accessToken.token_type} ${accessToken.access_token}`
        }
    });
};
/**
 * This function will get an access
 * token for the given url so you
 * can make an authenticated request to it
 * @param url
 * @returns
 */
export const fetchAccessToken = async (url) => {
    const urlObject = new URL(url);
    const authUrlObject = new URL(joinUrlPath(urlObject.toString(), `/oauth2/authorize`), urlObject);
    return await fetch(authUrlObject.toString(), {
        method: 'POST',
        body: JSON.stringify(authConfig || {}),
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(async (res) => {
        return (await res.json());
    })
        .then((tokenResponse) => {
        if (!tokenResponse.redirect_uri) {
            throw new Error(tokenResponse.error_description || 'Unknown Error');
        }
        return getQueryParams(tokenResponse.redirect_uri, '#');
    });
};
/**
 * This extracts the query params from the url
 * and create an object out of them and return
 * that object.
 * @param url complete url
 * @param queryStringSeparator like ? or # or anyother
 * after which query params are added to the url.
 * Default value is ?
 * @returns
 */
export const getQueryParams = (url, queryStringSeparator = '?') => {
    const [, query] = url.split(queryStringSeparator);
    return Object.fromEntries(new URLSearchParams(query));
};
export const joinUrlPath = (url, ...parts) => {
    const urlObject = new URL(url);
    const queryString = urlObject.search;
    urlObject.search = ''; // remove the query params
    const urlWithoutQueryParams = urlObject.toString();
    const joinedUrl = parts.reduce((resultingUrl, path) => {
        return `${strip(resultingUrl.trim(), '/')}/${strip(path.trim(), '/')}`;
    }, urlWithoutQueryParams);
    const joinedUrlObject = new URL(joinedUrl);
    joinedUrlObject.search = queryString; // attach the removed query params back
    return joinedUrlObject.toString();
};
/**
 * this strips the leading and
 * trailing characters from the string
 * @param str
 * @param characters
 * @returns
 */
export const strip = (str, characters) => {
    return str.replace(new RegExp(`(^[\\${characters}]+)|([\\${characters}]+$)`, 'g'), '');
};
